import { BRAND_LIST, CountryLanguageSwitcher, Languages } from 'typings'
import * as Typings from '../typings'

const ItalyLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'it',

  LONG_NAME: 'Italy',
  SHORT_NAME: 'IT',
  DISPLAY_COUNTRY: 'Deutschland',
  SHOW_TIME_IN_MILITARY: true,
  LANGUAGES: {
    IT: 'it',
    EN: 'en',
  },
  [BRAND_LIST.UQ]: {
    [Languages.IT]: {
      LANGUAGE_CODE: 'it',
      DISPLAY_NAME: 'Italy (Italian)',
      CONTACT_US_URL: 'https://faq-it.uniqlo.com/',
      HOME_PAGE_URL: 'https://www.uniqlo.com/it/it',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/it/it/',
      TERMS_OF_USE_URL:
        'https://faq-it.uniqlo.com/pkb_Home_UQ_IT?l=it&c=category_uq_eu_dk_se%3ARenew_UQIT_C7_2',
      PRIVACY_POLICY_URL:
        'https://faq-it.uniqlo.com/pkb_Home_UQ_IT?l=it&c=category_uq_eu_dk_se%3ARenew_UQIT_C7_3',
      AREAS: {
        '1': 'Abruzzo',
        '2': 'Basilicata',
        '3': 'Calabria',
        '4': 'Campania',
        '5': 'Emilia-Romagna',
        '6': 'Friuli-Venezia Giulia',
        '7': 'Lazio',
        '8': 'Liguria',
        '9': 'Lombardia',
        '10': 'Marche',
        '11': 'Molise',
        '12': 'Piemonte',
        '13': 'Puglia',
        '14': 'Sardegna',
        '15': 'Sicilia',
        '16': 'Toscana',
        '17': 'Trentino Alto Adige',
        '18': 'Umbria',
        '19': "Valle d'Aosta",
        '20': 'Vèneto',
      },
    },
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Italy (English)',
      HOME_PAGE_URL: 'https://www.uniqlo.com/it/en',
      MAP_MOBILE_URL: 'https://map.uniqlo.com/it/en/',
      CONTACT_US_URL: 'https://faq-it.uniqlo.com/pkb_Home_UQ_IT?l=en_US',
      TERMS_OF_USE_URL:
        'https://faq-it.uniqlo.com/pkb_Home_UQ_IT?l=en_US&c=category_uq_eu_dk_se%3ARenew_UQIT_C7_3',
      PRIVACY_POLICY_URL:
        'https://faq-it.uniqlo.com/pkb_Home_UQ_IT?l=en_US&c=category_uq_eu_dk_se%3ARenew_UQIT_C7_2',
      AREAS: {
        '1': 'Abruzzo',
        '2': 'Basilicata',
        '3': 'Calabria',
        '4': 'Campania',
        '5': 'Emilia-Romagna',
        '6': 'Friuli-Venezia Giulia',
        '7': 'Lazio',
        '8': 'Liguria',
        '9': 'Lombardy',
        '10': 'Marche',
        '11': 'Molise',
        '12': 'Piedmont',
        '13': 'Apulia',
        '14': 'Sardinia',
        '15': 'Sicily',
        '16': 'Tuscany',
        '17': 'Triento-South Tyrol',
        '18': 'Umbria',
        '19': 'Aosta Valley',
        '20': 'Vèneto',
      },
    },
  },
  GEO_COORDINATES: {
    INITIAL_LATITUDE: 41.178154,
    INITIAL_LONGITUDE: 12.71216,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  MAP_URL: 'https://www.uniqlo.com/it/it/content/Stores_Landing_Germany.html',
  POSTCODE_FORMAT: /^[0-9]{5}$/,
  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },
  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default ItalyLocale
